// components/OrderDetails.jsx
import React from 'react';
import constants from '../config/consts.js';
import './OrderDetails.css';

const statusLabels = {
    new: 'Новый',
    accepted: 'Принят',
    shipped: 'Отправлен',
    completed: 'Завершён',
    cancelled: 'Отменён'
};

const OrderDetails = ({ order, onClose }) => {
    const formatDate = (date) => {
        if (!date) return '—';
        return new Date(date).toLocaleString();
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="order-details-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Заказ #{order._id.slice(-8)}</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                <div className="modal-body">
                    <div className="info-section">
                        <h4>Информация о заказе</h4>
                        <div className="info-row">
                            <span className="label">Дата создания:</span>
                            <span>{formatDate(order.createdAt)}</span>
                        </div>
                        <div className="info-row">
                            <span className="label">Последнее обновление:</span>
                            <span>{formatDate(order.updatedAt)}</span>
                        </div>
                        <div className="info-row">
                            <span className="label">Статус:</span>
                            <span className={`status-badge status-${order.status}`}>{statusLabels[order.status]}</span>
                        </div>
                        <div className="info-row">
                            <span className="label">Трек-номер:</span>
                            <span>{order.trackingNumber || '—'}</span>
                        </div>
                        <div className="info-row">
                            <span className="label">Общая сумма:</span>
                            <span className="total-price">{order.totalPrice} ₽</span>
                        </div>
                    </div>

                    {order.user && (
                        <div className="info-section">
                            <h4>Покупатель</h4>
                            <div className="info-row">
                                <span className="label">ФИО:</span>
                                <span>{order.user.sname || ''} {order.user.fname || ''} {order.user.tname || ''}</span>
                            </div>
                            <div className="info-row">
                                <span className="label">Телефон:</span>
                                <span>{order.user.mobile || '—'}</span>
                            </div>
                            <div className="info-row">
                                <span className="label">Email:</span>
                                <span>{order.user.email || '—'}</span>
                            </div>
                            <div className="info-row">
                                <span className="label">Telegram:</span>
                                <span>{order.user.tg || '—'}</span>
                            </div>
                            <div className="info-row">
                                <span className="label">VK:</span>
                                <span>{order.user.vk || '—'}</span>
                            </div>
                            <div className="info-row">
                                <span className="label">Адрес:</span>
                                <span>{order.user.addres || '—'}</span>
                            </div>
                        </div>
                    )}

                    <div className="info-section">
                        <h4>Состав заказа</h4>
                        {order.positions && order.positions.length > 0 ? (
                            <table className="positions-table">
                                <thead>
                                    <tr>
                                        <th>Товар</th>
                                        <th>Кол-во</th>
                                        <th>Цена</th>
                                        <th>Сумма</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.positions.map((pos, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                <div className="product-info">
                                                    {pos.image && (
                                                        <img
                                                            src={`${constants.serverUrl}${pos.image}`}
                                                            alt={pos.title}
                                                            className="product-thumb"
                                                        />
                                                    )}
                                                    <span>{pos.title}</span>
                                                </div>
                                            </td>
                                            <td>{pos.quantity}</td>
                                            <td>{pos.price} ₽</td>
                                            <td>{pos.price * pos.quantity} ₽</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="3" className="total-label">Итого:</td>
                                        <td className="total-value">{order.totalPrice} ₽</td>
                                    </tr>
                                </tfoot>
                            </table>
                        ) : (
                            <p>Нет позиций</p>
                        )}
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="btn-secondary" onClick={onClose}>Закрыть</button>
                </div>
            </div>
        </div>
    );
};

export default OrderDetails;